'use strict';

export class Link {
  constructor() {
    console.log('Link module');
    $(".ct-mobile-navigation__top-menu .ct-menu__item__link").click(function(e) {
      e.preventDefault();
      var aid = $(this).attr("href");
      $('html,body').animate({scrollTop: $(aid).offset().top},'slow');
  });
  }
}
